import { render, staticRenderFns } from "./SpecialPayments.vue?vue&type=template&id=2b1fac52"
import script from "./SpecialPayments.vue?vue&type=script&lang=js"
export * from "./SpecialPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports